import React from 'react';
import { useReveal, PageHero } from '../Components/shared';
import MailForm from '../Components/mailForm';
import { Pin, Phone, Mail, Social } from '../Components/icons';
import { ORG, SOCIALS } from '../data/site';

const FIELDS = [
  { name: 'name', label: 'Full name', required: true, autoComplete: 'name' },
  { name: 'email', label: 'Email', type: 'email', required: true, autoComplete: 'email' },
  { name: 'topic', label: 'What is this about?', type: 'select', required: true, wide: true,
    options: ['Training programmes', 'A software project', 'Partnership or sponsorship', 'Something else'] },
  { name: 'message', label: 'Message', type: 'textarea', required: true, wide: true,
    placeholder: 'Tell us a little about what you need…' },
];

function Contact() {
  const ref = useReveal();
  return (
    <main id="main" ref={ref}>
      <PageHero
        eyebrow="Contact"
        title={["Let's talk."]}
        lead="Questions about training, a project you'd like built, or a partnership idea: we'd love to hear from you."
      />
      <section className="section section-tight">
        <div className="wrap contact-grid">
          <div data-reveal>
            <MailForm fields={FIELDS} submitLabel="Send message"
              subject={(d) => `[Website] ${d.get('topic')} from ${d.get('name')}`} />
          </div>
          <aside className="contact-side" data-reveal style={{ '--d': 1 }}>
            <a className="contact-item" href={`mailto:${ORG.email}`}>
              <span className="icon-chip sm"><Mail /></span>
              <span><small>Email</small>{ORG.email}</span>
            </a>
            <a className="contact-item" href={ORG.phoneHref}>
              <span className="icon-chip sm"><Phone /></span>
              <span><small>Phone</small>{ORG.phone}</span>
            </a>
            <div className="contact-item">
              <span className="icon-chip sm"><Pin /></span>
              <span><small>Location</small>{ORG.address}</span>
            </div>
            <ul className="socials on-light">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`EMANAC on ${s.label}`}><Social name={s.label} /></a>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </section>
    </main>
  );
}

export default Contact;
